import { useEffect, useState } from "react";
import { memberApi } from "../lib/api";
import { beltHex } from "../lib/beltColor";
import { QrCode, ArrowUpRight, DeviceMobile } from "@phosphor-icons/react";

// « Ma carte de membre » — une carte QR par élève lié au compte (portail /membres).
export default function MemberCardSection() {
  const [cards, setCards] = useState(null);

  useEffect(() => {
    memberApi.get("/member/pass").then((r) => setCards(r.data.cards || [])).catch(() => setCards([]));
  }, []);

  if (!cards || cards.length === 0) return null;

  return (
    <section className="border border-white/10 bg-[#0F0F0F] p-6 mb-8 kz-fade-up" data-testid="member-card-section">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <p className="kz-mono text-[10px] tracking-[0.26em] uppercase text-white/40">Carte de membre</p>
          <h2 className="kz-display text-2xl mt-1">Ma carte QR</h2>
          <p className="text-white/50 text-sm mt-1 max-w-md">
            Ta carte numérique pour le check-in à la tablette du dojo. Ouvre-la, puis « Enregistrer dans Photos » ou « Ajouter à l'écran d'accueil » — gratuit, sans app à installer.
          </p>
        </div>
        <DeviceMobile size={36} className="text-[#D90429]" weight="duotone" />
      </div>
      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {cards.map((c) => (
          <a key={c.contract_id} href={c.pass_path} target="_blank" rel="noreferrer"
            data-testid={`member-card-${c.contract_id}`}
            className="group flex items-center gap-4 border border-white/10 hover:border-[#D90429] bg-[#0A0A0A] px-4 py-3 transition-colors">
            <div className="w-12 h-12 bg-white flex items-center justify-center shrink-0">
              <QrCode size={30} className="text-black" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-white truncate">{c.full_name}</div>
              <div className="text-xs text-white/50 capitalize flex items-center gap-1.5 flex-wrap">
                {c.belt && <span className="inline-block w-2.5 h-2.5 rounded-full border border-white/30" style={{ backgroundColor: beltHex(c.belt) }} />}
                {c.belt ? `Ceinture ${c.belt} · ` : ""}{c.discipline}{c.pin ? ` · PIN ${c.pin}` : ""}
              </div>
            </div>
            <ArrowUpRight size={18} className="text-white/40 group-hover:text-[#D90429] transition-colors" />
          </a>
        ))}
      </div>
    </section>
  );
}
